<template>
  <div class="row">
    <div class="col-md-12">
      <img src="default.png" alt="default" v-if="is_tone==false" width="90%" height="auto">
      <img src="do.png" alt="default" v-if="tone=='do'" width="90%" height="auto">
      <img src="re.png" alt="default" v-if="tone=='re'" width="90%" height="auto">
      <img src="mi.png" alt="default" v-if="tone=='mi'" width="90%" height="auto">
      <img src="fa.png" alt="default" v-if="tone=='fa'" width="90%" height="auto">
      <img src="so.png" alt="default" v-if="tone=='so'" width="90%" height="auto">
      <img src="la.png" alt="default" v-if="tone=='la'" width="90%" height="auto">
      <img src="ti.png" alt="default" v-if="tone=='ti'" width="90%" height="auto">
      <img src="hido.png" alt="default" v-if="tone=='hido'" width="90%" height="auto">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tone',
  props: ["is_tone", "tone"],
  watch: {
    tone : function(new_val, old_val){
      console.log(new_val, old_val)
    }
  }
}
</script>

<style>
</style>